import { Component, OnInit, Input } from '@angular/core';
import stc from 'string-to-color';

@Component({
    selector: 'app-comment',
    templateUrl: './comment.component.html',
})
export class CommentComponent implements OnInit {
    public stc = stc;

    constructor() {}

    @Input() comment: any;

    ngOnInit() {}
}
